import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';
import { ensureLoaded } from '@/lib/ensure-loaded';
import { myRoleQuery } from '@/services/team-members';
import { parseSettingsSearch, type SettingsSearchInput } from '@/features/settings/settings-search';
import { SettingsPage } from '@/features/settings/settings-page';

export const Route = createFileRoute('/_authed/settings')({
  // Any section id (or the old `profile`); the page opens Profile for anything it doesn't show. Your numbers also takes
  // a card to bring up and the Who we look for scope to start on (CD30), each asked once. A door to Draper Knowledge Base
  // may name its exact place (a country's row or its editor, a document's facts, a rule) and the page to lead back to (F1).
  validateSearch: (search: SettingsSearchInput & SearchSchemaInput) => parseSettingsSearch(search),
  // Her role decides her sections: read it first, so a section her role leaves out (Draper Knowledge Base, Team & roles
  // for an Agency seat) is never drawn, and never asks the API, before the role arrives.
  loader: ({ context: { queryClient, team } }) => (team ? ensureLoaded(queryClient, myRoleQuery(team.id)).catch(() => null) : undefined),
  component: SettingsRoute,
});

function SettingsRoute() {
  const { section, card, country, document, fact, campaign, rule, edit, agency, back, scope } = Route.useSearch();
  // A door from elsewhere (the dock's Send feedback, a link) names its section: on a phone it opens straight to it.
  return (
    <SettingsPage
      section={section}
      card={card}
      country={country}
      document={document}
      fact={fact}
      campaign={campaign}
      rule={rule}
      edit={edit}
      agency={agency}
      back={back}
      scope={scope}
      opened={section !== 'account'}
    />
  );
}
